import NewsletterTwentyFiveContainer from "./container/NewsletterTwentyFiveContainer";
export default NewsletterTwentyFiveContainer;
